/* eslint-disable */
import { FormGroup, Label, Button } from "reactstrap";
import CoverUpload from "../FileUpload/CoverUpload";
import AvatarUpload from "../FileUpload/AvatarUpload";
import styles from "./Form.module.css";

const Step2 = (props) => {
  if (props.currentStep !== 2) {
    return null;
  }

  return (
    <>
      <FormGroup>
        <div>
          <Label className="mt-4 centerr" for="cover">
            <h4>Capa</h4>
          </Label>
          {props.cover && (
            <div className="centerr">
              <img
                width={400}
                src={URL.createObjectURL(props.cover)}
                alt="uploaded cover"
              />
            </div>
          )}
          <CoverUpload coverChange={props.handleCoverChange} />
          {props.cover !== null && props.isEditing === true && (
            <div className="centerr">
              <Button onClick={props.updateCover} className="mt-4">
                Atualizar Capa
              </Button>
            </div>
          )}
          <Label className="mt-4 centerr" for="avatar">
            <h4>Avatar</h4>
          </Label>
          {props.avatar && (
            <div className="centerr">
              <img
                width={160}
                height={160}
                className={styles.avatar}
                src={URL.createObjectURL(props.avatar)}
                alt="uploaded avatar"
              />
            </div>
          )}
          <AvatarUpload avatarChange={props.handleAvatarChange} />
          {props.avatar !== null && props.isEditing === true && (
            <div className="centerr">
              <Button onClick={props.updateAvatar} className="mt-4">
                Atualizar Avatar
              </Button>
            </div>
          )}
        </div>
      </FormGroup>
    </>
  );
};

export default Step2;
